import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { appState } from 'src/app/shared/interfaces/appState.interface';
import * as fromUser from 'src/app/redux/actions/session.action'
import { User, UserGoogle } from '@shared-logic/user/user.interface';
import { Subscription } from 'rxjs';
import { GoogleLoginProvider, SocialUser } from '@abacritt/angularx-social-login';
import { TokenService } from 'src/app/shared/services/token.service';
import { getCookie } from 'src/app/shared/session.checker';
import { localStorageNames } from 'src/app/shared/const/localStorageNames';
import { AuthService } from 'src/app/shared/services/auth.service';
import { loginFailed } from 'src/app/redux/actions/login.action';

declare var google: any;
export declare var gapi: any;

export const CLIENT_ID: string = "313888454615-f6tnmff1964pee1ch3hdqfbf4v115r5i.apps.googleusercontent.com"

@Component({
  selector: 'app-boton-google',
  templateUrl: './boton-google.component.html',
  styleUrls: ['./boton-google.component.scss']
})
export class BotonGoogleComponent implements OnInit {
  info!: string;
  showError: boolean = false;
  messageError: string = '';

  private login$!: Subscription;

  GoogleLoginProvider = GoogleLoginProvider;

  constructor(private store: Store<appState>, private tokenSvc: TokenService,
    private authSvc: AuthService
  ) {
    this.setSubscriptions();
  }

  ngOnInit() {
    this.authSvc.afauth.authState.subscribe((user: SocialUser) => {
      this.handleCredentialResponse(user?.email, user?.photoUrl, user?.id);
    });
  }

  ngOnDestroy(): void {
    this.login$?.unsubscribe();
  }

  setSubscriptions() {
    this.login$ = this.store.select('login').subscribe(state => {
      this.showError = state.showError;
      this.messageError = state.error;
    })
  }

  login() {
    this.store.dispatch(fromUser.login());
  }

  handleCredentialResponse(email: string | undefined, photo: string | undefined, id: string | undefined) {
    //We decode the jwt
    console.log("Callback")

    if (!email || !photo || !id) {
      return;
    }

    //Create an UserGoogle
    const user: UserGoogle = {
      email: email,
      photo: photo,
      id: id,
    }

    //Create an User
    this.store.dispatch(fromUser.createUser({
      photo: user.photo,
      email: user.email,
      id: user.id
    }))
  }
}